<template>
  <div class="modal-container">
    <div class="add-box clearfix">
      <div class="detail clearfix">
        <h2 style="margin-bottom: 10px">关联订单</h2>
        <span v-if="isHavePermission('global:viewCreateTime')"
          >物流编号：{{ tableData[0].logisticsNum }} | 创建操作人：{{
            tableData[0].createUser
          }}
          | 创建日期：{{ tableData[0].createTime | timeFormatDate }}</span
        >
        <span v-else
          >物流编号：{{ tableData[0].logisticsNum }} | 创建操作人：{{
            tableData[0].createUser
          }}</span
        >
      </div>
      <vxe-table
        border
        show-overflow
        ref="xTable1"
        class="table-style"
        max-height="400"
        :auto-resize="true"
        :data="tableData"
        :edit-rules="formRules"
        :edit-config="{ trigger: 'click', mode: 'cell' }"
      >
        <vxe-table-column field="chainNum" title="主订单编号">
        </vxe-table-column>
        <vxe-table-column field="sellerOrdersNum" title="子订单编号">
          <template v-slot="{ row }">
            <a
              class="sel-link"
              @click="openLink()"
              target="_black"
              style="cursor: pointer"
            >
              {{
                row.ordersSellerLv2Num
                  ? row.ordersSellerLv2Num
                  : row.ordersSellerNum
                  ? row.ordersSellerNum
                  : "选择关联订单"
              }}
            </a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="buyerName" title="托运人名称">
        </vxe-table-column>
        <vxe-table-column field="compName" title="平台企业">
          <template v-slot="{ row }">
            <platform-corp
              v-if="!row.ordersSellerLv2Num && !row.ordersSellerNum"
              :row="row"
              :field="'compName'"
              :placeholder="'请选择平台企业'"
            ></platform-corp>
            <span
              v-if="row.ordersSellerLv2Num || row.ordersSellerNum"
              class="sel-link"
              >{{ row.compName }}</span
            >
          </template>
        </vxe-table-column>
        <vxe-table-column field="sellerName" title="承运人名称">
        </vxe-table-column>
        <vxe-table-column field="sellerNameLv2" title="实际承运人名称">
        </vxe-table-column>
      </vxe-table>
      <h2 style="margin-top: 20px">物流信息</h2>
      <vxe-table
        border
        show-overflow
        ref="xTable2"
        class="table-style"
        max-height="400"
        :auto-resize="true"
        :data="goodsData"
        :edit-rules="formRules"
        :edit-config="{ trigger: 'click', mode: 'cell' }"
      >
        <vxe-table-column field="logisticsCode" title="物流单号" width="130">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.logisticsCode"
              placeholder="选填"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="isTop" title="状态" width="120">
          <template v-slot="scope">
            <vxe-select
              v-model="scope.row.isTop"
              placeholder="请选择"
              :options="isTopTypeOptions"
              @change="clearV"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsType" title="货物类型" width="140">
          <template v-slot="scope">
            <vxe-select
              v-model="scope.row.goodsType"
              placeholder="请选择"
              :options="goodsTypeOptions"
              @change="clearV"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="90">
          <template v-slot="scope">
            <vxe-input
              v-model="scope.row.goodsName"
              placeholder="必填"
              @blur="clearV"
              @input="$refs.xTable.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRule" title="规格" width="70">
          <template v-slot="{ row }">
            <vxe-input v-model="row.goodsRule" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="counts" title="装货数量" width="80">
          <template v-slot="scope">
            <vxe-input
              v-model="scope.row.counts"
              placeholder="必填"
              @blur="clearV"
              v-on:input="countDeviate(scope.row)"
              type="number"
              @input="$refs.xTable2.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="realCount" title="实际数量" width="80">
          <template v-slot="scope">
            <vxe-input
              v-model="scope.row.realCount"
              placeholder="必填"
              @blur="clearV"
              v-on:input="countDeviate(scope.row)"
              type="number"
              @input="$refs.xTable2.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="deviate" title="盈亏数量" width="80">
          <template v-slot="scope">
            <vxe-input
              v-model="scope.row.deviate"
              placeholder="必填"
              @blur="clearV"
              type="number"
              @input="$refs.xTable2.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsUnit" title="单位" width="70">
          <template v-slot="scope">
            <vxe-select
              v-model="scope.row.goodsUnit"
              placeholder="请选择"
              :options="unitTypeOptions"
              @change="clearV"
              transfer
            ></vxe-select>
            <!-- <vxe-input v-model="scope.row.goodsUnit" placeholder="必填" @blur="clearV"
                       @input="$refs.xTable2.updateStatus(scope)"></vxe-input> -->
          </template>
        </vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="120">
          <template v-slot="{ row }">
            <a
              class="sel-link"
              @click="openCarShip()"
              target="_black"
              style="cursor: pointer"
            >
              {{
                row.carShipNum === null || row.carShipNum === ""
                  ? "请选择车船"
                  : row.carShipNum
              }}
            </a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="voyage" title="航次号" width="80">
          <template v-slot="{ row }">
            <vxe-input v-model="row.voyage" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column field="deliveryPlace" title="交货地点" width="70">
          <template v-slot="{ row }">
            <vxe-input v-model="row.deliveryPlace" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column> -->
        <!-- <vxe-table-column field="beginPlace" title="起运地" width="70">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.beginPlace" placeholder="必填" @blur="clearV"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column> -->
        <!-- <vxe-table-column field="beginPlaceArea" title="起运地" width="200">
          <template v-slot="{ row }">
            <Cascader
              :data="cityData"
              :load-data="loadData"
              :disabled="row.logisticsType !== 1"
              v-model="row.beginPlaceArea"
              transfer
            ></Cascader>
          </template>
        </vxe-table-column> -->
        <vxe-table-column field="province" title="起运地(省)" width="100">
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
              v-model="row.province"
              :options="cityData"
              @change="loadCity(row.province, $rowIndex, 1)"
              @blur="clearV"
              :disabled="row.logisticsType !== 1"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="city" title="起运地(市)" width="100">
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
              v-model="row.city"
              :options="row.cityOptions"
              @change="loadArea(row.province, row.city, $rowIndex, 1)"
              @blur="clearV"
              :disabled="row.logisticsType !== 1"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="area" title="起运地(区)" width="100">
          <template v-slot="{ row }">
            <vxe-select
              v-model="row.area"
              :options="row.areaOptions"
              @blur="clearV"
              :disabled="row.logisticsType !== 1"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="beginPlaceAddress"
          title="详细地址"
          width="160"
        >
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.beginPlaceAddress"
              placeholder="起运地"
              @focus="clearV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="beginTime" title="起运时间" width="200">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.beginTime"
              placeholder="选择日期"
              :type="row.logisticsType === 2 ? 'date' : 'datetime'"
              transfer
            ></vxe-input>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column field="beginTime" title="起运时间" width="110">
          <template v-slot="{ row }">
            <vxe-input v-model="row.beginTime" placeholder="选择日期" type="date" transfer></vxe-input>
          </template>
        </vxe-table-column> -->
        <!-- <vxe-table-column field="endPlace" title="到达地" width="70">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.endPlace" placeholder="必填" @blur="clearV"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column> -->
        <!-- <vxe-table-column field="endPlaceArea" title="到达地" width="200">
          <template v-slot="{ row }">
            <Cascader
              :data="cityData"
              :load-data="loadData"
              :disabled="row.logisticsType !== 1"
              v-model="row.endPlaceArea"
              transfer
            ></Cascader>
          </template>
        </vxe-table-column> -->
        <vxe-table-column field="endProvince" title="到达地(省)" width="100">
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
              v-model="row.endProvince"
              :options="cityData"
              @change="loadCity(row.endProvince, $rowIndex, 2)"
              @blur="clearV"
              :disabled="row.logisticsType !== 1"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endCity" title="到达地(市)" width="100">
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
              v-model="row.endCity"
              :options="row.endCityOptions"
              @change="loadArea(row.endProvince, row.endCity, $rowIndex, 2)"
              @blur="clearV"
              :disabled="row.logisticsType !== 1"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endArea" title="到达地(区)" width="100">
          <template v-slot="{ row }">
            <vxe-select
              v-model="row.endArea"
              :options="row.endAreaOptions"
              @blur="clearV"
              :disabled="row.logisticsType !== 1"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endPlaceAddress" title="详细地址" width="160">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.endPlaceAddress"
              placeholder="到达地"
              @focus="clearV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endTime" title="到达时间" width="200">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.endTime"
              placeholder="选择日期"
              :type="row.logisticsType === 2 ? 'date' : 'datetime'"
              transfer
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="note" title="备注" width="80">
          <template v-slot="{ row }">
            <vxe-input v-model="row.note" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-table
        border
        show-overflow
        :auto-resize="true"
        class="table-upload-style"
        max-height="200"
        :data="goodsData"
        :edit-config="{ trigger: 'click', mode: 'cell' }"
      >
        <vxe-table-column field="url" title="上传附件">
          <template v-slot="{ row }">
            <upload-list
              :isEdit="true"
              :row="row"
              :initFileList="uploadList"
              :view="'arrange'"
            ></upload-list>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box">
      <Button status="primary" @click="save">保 存</Button>
    </div>
    <vxe-modal
      v-model="orderVisible"
      title="选择订单"
      width="1300"
      height="600"
      resize
      position="center"
    >
      <choose-order ref="orderModal" @choose="chooseOrder"></choose-order>
    </vxe-modal>
    <vxe-modal
      v-model="carShipVisible"
      title="选择车船"
      width="1300"
      height="600"
      resize
      position="center"
    >
      <choose-car-ship
        ref="carShipModal"
        @choose="chooseCarShip"
      ></choose-car-ship>
    </vxe-modal>
  </div>
</template>

<script>
import $C from "@/consts/index";
import $api from "@/apiProvider";
import ChooseOrder from "@/components/modal/ChooseRelationOrder";
import ChooseCarShip from "@/components/modal/ChooseCarShip";
import auth from "@/utils/auth";
import UploadList from "@/components/common/UploadList";
import { showLoading, hideLoading, isEmpty, isNotEmpty } from "@/utils/util";
import PlatformCorp from "@/components/common/PlatformCorp";
import getAuthOrization from "@/mixin/getAuthOrization";
import moment from "moment";
var appData = require("@/assets/json/zz.json");

export default {
  mixins: [getAuthOrization],
  components: { ChooseOrder, ChooseCarShip, UploadList, PlatformCorp },
  data() {
    return {
      formRules: {
        goodsName: [{ required: true, message: "请输入货名" }],
        counts: [{ required: true, message: "请输入装货数量" }],
        deviate: [{ required: true, message: "请输入盈亏数量" }],
        realCount: [{ required: true, message: "请输入实际数量" }],
        goodsUnit: [{ required: true, message: "请输入单位" }],
        carShipNum: [{ required: true, message: "请选择车船号" }],
        // beginPlace: [{ required: true, message: "请输入起运地" }],
        // endPlace: [{ required: true, message: "请输入到达地" }],
        beginTime: [{ required: true, message: "请选择起运时间" }],
        beginPlaceAddress: [
          { required: true, message: "请输入起运地详细地址" }
        ],
        endPlaceAddress: [{ required: true, message: "请输入到达地详细地址" }],
        // beginPlaceArea: [{ validator: this.requireValid }],
        // endPlaceArea: [{ validator: this.requireValid }],
        province: [{ validator: this.requireValid }],
        city: [{ validator: this.requireValid }],
        area: [{ validator: this.requireValid }],
        endProvince: [{ validator: this.requireValid }],
        endCity: [{ validator: this.requireValid }],
        endArea: [{ validator: this.requireValid }]
        // endTime: [
        //   {required: true, message: "请选择到达时间"},
        // ],
      },
      tableData: [
        {
          logisticsNum: ""
        }
      ],
      goodsData: [
        {
          fileUuidList: []
        }
      ],
      orderVisible: false,
      carShipVisible: false,
      uploadData: [
        {
          url: ""
        }
      ],
      uploadList: [],
      file: null, // 上传
      actionUrl: "", // 初始化上传地址
      uploadHeaders: {
        Authorization: auth.getAuth().token,
        token: auth.getAuth().token
      },
      viewer: null,
      goodsTypeOptions: [],
      unitTypeOptions: [],
      cityData: [],
      isTopTypeOptions: $C.LogisticsIsTopStatus.options
    };
  },
  mounted() {
    this.getDicDate();
  },
  methods: {
    getDicDate() {
      this.goodsTypeOptions = [];
      this.unitTypeOptions = [];
      $api.other.getGoodsTypeModel
        .GET({
          params: {
            page: 1,
            rows: 100
          }
        })
        .then(res => {
          res.data.forEach(item => {
            var obj = {
              label: item.dictText,
              value: item.dictText
            };
            this.goodsTypeOptions.push(obj);
          });
        });
      $api.other.getUnitTypeModel
        .GET({
          params: {
            page: 1,
            rows: 100
          }
        })
        .then(res => {
          res.data.forEach(item => {
            var obj = {
              label: item.dictText,
              value: item.dictText
            };
            this.unitTypeOptions.push(obj);
          });
        });

      appData.forEach(item => {
        let obj = {
          value: item.label,
          label: item.label
          // children: [],
          // loading: false
        };
        this.cityData.push(obj);
      });
    },
    getCityOptions(province) {
      if (isEmpty(province)) {
        return [];
      }
      let options;
      let cityOptions = appData.filter(i => i.label === province);
      let isHasChildren = cityOptions[0].children.some(m =>
        isNotEmpty(m.children)
      );
      if (isHasChildren) {
        let arr = cityOptions[0].children.map(i => {
          return {
            label: i.label,
            value: i.label
          };
        });
        options = arr;
      } else {
        let cityArr = [
          {
            label: province,
            value: province
          }
        ];
        options = cityArr;
      }
      return options;
    },
    getAreaOptions(province, city) {
      if (isEmpty(province)) {
        return [];
      }
      let cityOptions = appData.filter(i => i.label === province);
      let arr = [];
      if (province === city) {
        arr = cityOptions[0].children.map(i => {
          return {
            label: i.label,
            value: i.label
          };
        });
      } else {
        let areaOptions = cityOptions[0].children.filter(i => i.label === city);
        arr = areaOptions[0].children.map(i => {
          return {
            label: i.label,
            value: i.label
          };
        });
      }
      return arr;
    },
    loadCity(province, index, type, isImpot = false) {
      let tableData = this.$refs.xTable2.getTableData().tableData;
      if (!isImpot) {
        if (type === 1) {
          tableData[index].city = "";
          tableData[index].area = "";
        } else {
          tableData[index].endCity = "";
          tableData[index].endArea = "";
        }
      }

      let cityOptions = appData.filter(i => i.label === province);
      let isHasChildren = cityOptions[0].children.some(m =>
        isNotEmpty(m.children)
      );
      if (isHasChildren) {
        let arr = cityOptions[0].children.map(i => {
          return {
            label: i.label,
            value: i.label
          };
        });
        type === 1
          ? (tableData[index].cityOptions = arr)
          : (tableData[index].endCityOptions = arr);
      } else {
        let cityArr = [
          {
            label: province,
            value: province
          }
        ];
        type === 1
          ? (tableData[index].cityOptions = cityArr)
          : (tableData[index].endCityOptions = cityArr);
      }
    },
    loadArea(province, city, index, type, isImpot = false) {
      let tableData = this.$refs.xTable2.getTableData().tableData;
      if (!isImpot) {
        if (type === 1) {
          tableData[index].area = "";
        } else {
          tableData[index].endArea = "";
        }
      }
      let cityOptions = appData.filter(i => i.label === province);
      let arr = [];
      if (province === city) {
        arr = cityOptions[0].children.map(i => {
          return {
            label: i.label,
            value: i.label
          };
        });
      } else {
        let areaOptions = cityOptions[0].children.filter(i => i.label === city);
        arr = areaOptions[0].children.map(i => {
          return {
            label: i.label,
            value: i.label
          };
        });
      }
      type === 1
        ? (tableData[index].areaOptions = arr)
        : (tableData[index].endAreaOptions = arr);
    },
    loadData(item, callback) {
      const getTree = jsonObj => {
        function toParse(jsonObj) {
          jsonObj.forEach(item => {
            item.value = item.label;
            if (item.children && Array.isArray(item.children)) {
              toParse(item.children);
            }
          });
          return jsonObj;
        }
        return toParse(jsonObj);
      };
      var curCityData = getTree(appData);
      item.loading = true;
      setTimeout(() => {
        let arr = curCityData.filter(i => {
          return i.label === item.value;
        });
        item.children = arr[0].children;
        item.loading = false;
        callback();
      }, 1000);
    },
    async requireValid(e) {
      // if (
      //   e.row.logisticsType === 1 &&
      //   e.column.title == "起运地" &&
      //   isEmpty(e.row.beginPlaceArea)
      // ) {
      //   return Promise.reject(new Error("请选择起运地省市区/县"));
      // }
      // if (
      //   e.row.logisticsType === 1 &&
      //   e.column.title == "到达地" &&
      //   isEmpty(e.row.endPlaceArea)
      // ) {
      //   return Promise.reject(new Error("请选择到达地省市区/县"));
      // }
      if (
        e.row.logisticsType === 1 &&
        e.column.title == "起运地(省)" &&
        isEmpty(e.row.province)
      ) {
        return Promise.reject(new Error("请选择起运地省"));
      }
      if (
        e.row.logisticsType === 1 &&
        e.column.title == "起运地(市)" &&
        isEmpty(e.row.city)
      ) {
        return Promise.reject(new Error("请选择起运地市"));
      }
      if (
        e.row.logisticsType === 1 &&
        e.column.title == "起运地(区)" &&
        isEmpty(e.row.area)
      ) {
        return Promise.reject(new Error("请选择起运地区"));
      }
      if (
        e.row.logisticsType === 1 &&
        e.column.title == "到达地(省)" &&
        isEmpty(e.row.endProvince)
      ) {
        return Promise.reject(new Error("请选择到达地省"));
      }
      if (
        e.row.logisticsType === 1 &&
        e.column.title == "到达地(市)" &&
        isEmpty(e.row.endCity)
      ) {
        return Promise.reject(new Error("请选择到达地市"));
      }
      if (
        e.row.logisticsType === 1 &&
        e.column.title == "到达地(区)" &&
        isEmpty(e.row.endArea)
      ) {
        return Promise.reject(new Error("请选择到达地区"));
      }
    },
    countDeviate(row) {
      if (row.counts && row.realCount) {
        let count = row.counts - row.realCount;
        row.deviate = Math.round(count * 100) / 100;
      } else {
        row.deviate = null;
      }
    },
    async validEvent() {
      let errMap = await this.$refs.xTable2.validate().catch(errMap => errMap);
      return errMap ? false : true;
    },
    openLink() {
      this.$refs.orderModal.init();
      this.orderVisible = true;
    },
    chooseOrder(row, key) {
      // console.log(row);
      // debugger
      this.tableData[0].ordersSellerId = null;
      this.tableData[0].ordersSellerLv2Id = null;
      this.tableData[0].ordersSellerNum = null;
      this.tableData[0].ordersSellerLv2Num = null;
      this.tableData[0][key] = row.id;
      if (key === "ordersSellerId") {
        this.tableData[0].ordersSellerNum = row.sellerOrdersNum;
        this.tableData[0].compName = row.buyerName;
      } else {
        this.tableData[0].ordersSellerLv2Num = row.sellerOrdersNum;
        this.tableData[0].compName = row.platformCompany;
      }
      this.tableData[0].sellerName = row.sellerName;
      this.tableData[0].buyerName = row.buyerName;
      this.tableData[0].sellerNameLv2 = row.parentSellerName;
      this.tableData[0].chainNum = row.chainNum;
      this.goodsData[0].goodsName = row.goodsName;
      if (row.goodsRtnVos && row.goodsRtnVos.length > 0) {
        this.goodsData[0].goodsType = row.goodsRtnVos[0].goodsType;
        this.goodsData[0].beginPlaceAddress =
          row.goodsRtnVos[0].beginPlaceAddress;
        this.goodsData[0].endPlaceAddress = row.goodsRtnVos[0].endPlaceAddress;
        let beginPlaceArea;
        if (row.goodsRtnVos[0].beginPlaceArea) {
          if (Array.isArray(row.goodsRtnVos[0].beginPlaceArea)) {
            beginPlaceArea = row.goodsRtnVos[0].beginPlaceArea;
          } else {
            beginPlaceArea = row.goodsRtnVos[0].beginPlaceArea.split(",");
          }
          if (beginPlaceArea.length == 2) {
            this.goodsData[0].city = beginPlaceArea[0];
            this.goodsData[0].area = beginPlaceArea[1];
          } else {
            this.goodsData[0].city = beginPlaceArea[1];
            this.goodsData[0].area = beginPlaceArea[2];
          }
          this.goodsData[0].province = beginPlaceArea[0];
          this.loadCity(this.goodsData[0].province, 0, 1, true);
          this.loadArea(
            this.goodsData[0].province,
            this.goodsData[0].city,
            0,
            1,
            true
          );
        } else {
          this.goodsData[0].province = "";
          this.goodsData[0].city = "";
          this.goodsData[0].area = "";
        }
        let endPlaceArea;
        if (row.goodsRtnVos[0].endPlaceArea) {
          if (Array.isArray(row.goodsRtnVos[0].endPlaceArea)) {
            endPlaceArea = row.goodsRtnVos[0].endPlaceArea;
          } else {
            endPlaceArea = row.goodsRtnVos[0].endPlaceArea.split(",");
          }
          if (endPlaceArea.length == 2) {
            this.goodsData[0].endCity = endPlaceArea[0];
            this.goodsData[0].endArea = endPlaceArea[1];
          } else {
            this.goodsData[0].endCity = endPlaceArea[1];
            this.goodsData[0].endArea = endPlaceArea[2];
          }
          this.goodsData[0].endProvince = endPlaceArea[0];
          this.loadCity(this.goodsData[0].endProvince, 0, 2, true);
          this.loadArea(
            this.goodsData[0].endProvince,
            this.goodsData[0].endCity,
            0,
            2,
            true
          );
        } else {
          this.goodsData[0].endProvince = "";
          this.goodsData[0].endCity = "";
          this.goodsData[0].endArea = "";
        }
      } else {
        this.goodsData[0].goodsType = null;
      }
      this.goodsData[0].goodsRule = row.rule;
      this.goodsData[0].goodsUnit = row.unit;
      this.goodsData[0].price = row.price;
      this.goodsData[0].carShipNum = row.carShipNum;
      this.goodsData[0].beginPlace = row.beginPlace;
      this.goodsData[0].endPlace = row.endPlace;
      this.goodsData[0].voyage = row.voyage;
      this.goodsData[0].deliveryPlace = row.deliveryPoints;
      this.goodsData[0].logisticsType = row.transportationType;
      this.$refs.orderModal.close();
      this.orderVisible = false;
    },
    openCarShip() {
      this.carShipVisible = true;
      this.$refs.carShipModal.init();
    },
    chooseCarShip(row, type) {
      if (type === "ship") {
        this.goodsData[0].carShipNum = row.shipName;
        this.goodsData[0].carShipId = row.id;
        this.goodsData[0].logisticsType = 2;
      } else {
        this.goodsData[0].carShipNum = row.carNum;
        this.goodsData[0].carShipId = row.id;
        this.goodsData[0].logisticsType = 1;
      }
      this.$refs.carShipModal.close();
      this.carShipVisible = false;
    },
    async save() {
      //编辑清空
      if (this.tableData[0].ordersSellerLv2Id) {
        this.tableData[0].ordersSellerId = null;
      }
      let sts = await this.validEvent();
      if (!sts) {
        this.$XModal.message({ status: "error", message: "校验不通过！" });
        return;
      }
      let data = this.tableData[0];
      let goods = this.goodsData[0];
      for (let key in goods) {
        if (Object.prototype.hasOwnProperty.call(goods, key)) {
          //此处hasOwnProperty是判断自有属性，使用 for in 循环遍历对象的属性时，原型链上的所有属性都将被访问会避免原型对象扩展带来的干扰
          data[key] = goods[key];
        }
      }
      if (data.endTime !== null && data.endTime !== "") {
        if (
          this.$utils.timestamp(data.beginTime) >
          this.$utils.timestamp(data.endTime)
        ) {
          this.$XModal.alert({
            message: "到达时间不能早于到达时间",
            status: "error"
          });
          return;
        }
      }
      data.beginTime = this.$utils.timestamp(data.beginTime);
      if (data.endTime && data.endTime !== "") {
        data.endTime = this.$utils.timestamp(data.endTime);
      }
      if (data.logisticsType == 1) {
        // data.beginPlaceArea = data.beginPlaceArea.join("");
        // data.endPlaceArea = data.endPlaceArea.join("");
        // data.beginPlace = data.beginPlaceArea + data.beginPlaceAddress;
        // data.endPlace = data.endPlaceArea + data.endPlaceAddress;
        // let beginPlaceArea = isNotEmpty(data.beginPlaceArea)
        //   ? data.beginPlaceArea.join(",")
        //   : "";
        // let beginPlaceArea2 = isNotEmpty(data.beginPlaceArea)
        //   ? data.beginPlaceArea.join("")
        //   : "";
        // let endPlaceArea = isNotEmpty(data.endPlaceArea)
        //   ? data.endPlaceArea.join(",")
        //   : "";
        // let endPlaceArea2 = isNotEmpty(data.endPlaceArea)
        //   ? data.endPlaceArea.join("")
        //   : "";
        let beginPlaceArea = isNotEmpty(data.area)
          ? data.province === data.city
            ? `${data.city},${data.area}`
            : `${data.province},${data.city},${data.area}`
          : "";
        let beginPlaceArea2 = isNotEmpty(data.area)
          ? data.province === data.city
            ? `${data.city}${data.area}`
            : `${data.province}${data.city}${data.area}`
          : "";

        let endPlaceArea = isNotEmpty(data.endArea)
          ? data.endProvince === data.endCity
            ? `${data.endCity},${data.endArea}`
            : `${data.endProvince},${data.endCity},${data.endArea}`
          : "";
        let endPlaceArea2 = isNotEmpty(data.endArea)
          ? data.endProvince === data.endCity
            ? `${data.endCity}${data.endArea}`
            : `${data.endProvince}${data.endCity}${data.endArea}`
          : "";
        let beginPlaceAddress = isNotEmpty(data.beginPlaceAddress)
          ? data.beginPlaceAddress
          : "";
        let endPlaceAddress = isNotEmpty(data.endPlaceAddress)
          ? data.endPlaceAddress
          : "";
        let beginPlace = beginPlaceArea2 + beginPlaceAddress;
        let endPlace = endPlaceArea2 + endPlaceAddress;
        data.beginPlaceArea = beginPlaceArea;
        data.endPlaceArea = endPlaceArea;
        data.beginPlace = beginPlace;
        data.endPlace = endPlace;
        data.beginPlaceAddress = beginPlaceAddress;
        data.endPlaceAddress = endPlaceAddress;
      } else {
        data.beginPlaceArea = "";
        data.endPlaceArea = "";
        data.beginPlace = data.beginPlaceAddress;
        data.endPlace = data.endPlaceAddress;
      }
      showLoading();
      let res = await $api.logistics.request("updateLogistics", data);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("修改成功");
        this.close();
        this.$emit("afterSave");
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    },
    async queryLogisticsDetail(id) {
      let res = await $api.logistics.request("queryLogisticsDetail", {
        id: id
      });
      if (res.status === 1) {
        let data = res.data;
        this.tableData = [];
        this.tableData.push(data);
        this.tableData.map(i => {
          i.createTime = this.$utils.toDateString(i.createTime, "yyyy-MM-dd");
          if (i.ordersSellerLv2Num === null || i.ordersSelleLv2Num === "") {
            if (i.ordersSellerNum === null || i.ordersSellerNum === "") {
              i.sellerOrdersNum = i.ordersBuyerNum;
            } else {
              i.sellerOrdersNum = i.ordersSellerNum;
            }
          } else {
            i.sellerOrdersNum = i.ordersSellerLv2Num;
          }
        });
        let fileUuidList = [];
        if (data.fileList) {
          data.fileList.map(i => {
            fileUuidList.push(i.uuid);
            this.uploadList.push(i);
          });
        }
        this.tableData[0].compName = data.compName;
        let beginPlaceArea = isEmpty(data.beginPlaceArea)
          ? []
          : data.beginPlaceArea.split(",");
        let endPlaceArea = isEmpty(data.endPlaceArea)
          ? []
          : data.endPlaceArea.split(",");
        let province;
        let city;
        let area;
        let endProvince;
        let endCity;
        let endArea;

        if (beginPlaceArea.length > 0) {
          if (beginPlaceArea.length == 2) {
            city = beginPlaceArea[0];
            area = beginPlaceArea[1];
          } else {
            city = beginPlaceArea[1];
            area = beginPlaceArea[2];
          }
          province = beginPlaceArea[0];
        } else {
          province = "";
          city = "";
          area = "";
        }
        if (endPlaceArea.length > 0) {
          if (endPlaceArea.length == 2) {
            endCity = endPlaceArea[0];
            endArea = endPlaceArea[1];
          } else {
            endCity = endPlaceArea[1];
            endArea = endPlaceArea[2];
          }
          endProvince = endPlaceArea[0];
        } else {
          endProvince = "";
          endCity = "";
          endArea = "";
        }
        this.goodsData = [
          {
            logisticsCode: data.logisticsCode,
            logisticsType: data.logisticsType,
            isTop: data.isTop,
            goodsName: data.goodsName,
            goodsType: data.goodsType,
            goodsRule: data.goodsRule,
            counts: data.counts,
            deviate: data.deviate,
            realCount: data.realCount,
            goodsUnit: data.goodsUnit,
            carShipNum: data.carShipNum,
            voyage: data.voyage,
            deliveryPlace: data.deliveryPlace,
            // beginPlace: data.beginPlace,
            beginTime:
              data.beginTime && data.beginTime !== ""
                ? moment(data.beginTime).format("YYYY-MM-DD HH:mm:ss")
                : "",
            // endPlace: data.endPlace,
            // beginPlaceArea,
            beginPlaceAddress: data.beginPlaceAddress,
            // endPlaceArea,
            province,
            city,
            area,
            endProvince,
            endCity,
            endArea,
            cityOptions: this.getCityOptions(province),
            endCityOptions: this.getCityOptions(endProvince),
            areaOptions: this.getAreaOptions(province, city),
            endAreaOptions: this.getAreaOptions(endProvince, endCity),
            endPlaceAddress: data.endPlaceAddress,
            endTime:
              data.endTime && data.endTime !== ""
                ? moment(data.endTime).format("YYYY-MM-DD HH:mm:ss")
                : "",
            note: data.note,
            fileUuidList: fileUuidList
          }
        ];
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    },
    close() {
      this.tableData = [
        {
          logisticsNum: ""
        }
      ];
      this.goodsData = [
        {
          fileUuidList: []
        }
      ];
      this.uploadList = [];
      this.clearV();
    },
    clearV() {
      this.$refs.xTable2.clearValidate();
    }
  }
};
</script>

<style scoped>
.modal-container {
  position: relative;
  height: 100%;
}

.modal-footer {
  padding: 10px 0 0 0;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
}

.detail {
  display: flex;
  align-items: center;
}

h2 {
  color: #17233d;
  font-size: 18px;
}

.detail span {
  margin-left: auto;
  font-size: 14px;
  color: #808695;
}
</style>